export default __webpack_public_path__ + "static/media/jem.d95cb0f1.png";